/**
 * Current legal document versions.
 *
 * Bump these when the Terms of Service or Privacy Policy change materially.
 * Used by:
 *   - Backend: stamped onto every `user_terms_acceptance` row so we can prove
 *     which version a user assented to at which time.
 *   - Frontend (future #140): the `<TermsReconsentGate>` compares the user's
 *     most-recent accepted version against these constants to decide whether
 *     to show a re-consent modal before allowing continued use.
 *
 * Format: ISO date (YYYY-MM-DD) matching the "Last Updated" line in
 * `design-artifacts/legal/terms-of-service.md` and `privacy-policy.md`.
 *
 * Changing either value has user-visible consequences: every existing user
 * whose stored version does not match will be prompted to re-accept.
 */
export const CURRENT_TERMS_VERSION = '2026-05-10' as const
export const CURRENT_PRIVACY_VERSION = '2026-05-10' as const

export type TermsAcceptanceMethod = 'email' | 'google' | 'reconsent'
